import { useMemo } from "react";
import { useConnect, useDisconnect } from "./account";
import { walletTypeFromRujira } from "../rujira/wallet";
import { WalletType } from "./wallet";
import { useRujiraStore } from "../rujira/store";
import { useAccountStore } from "../shared/store";
export const useRujiraAccountProvider = () => {
    const accounts = useRujiraStore((state) => {
        return state.accounts;
    }, (prev, next) => {
        if (prev.length !== next.length) {
            return false;
        }
        const sorter = (a, b) => {
            return a.account.address.localeCompare(b.account.address);
        };
        const sortedPrev = [...prev].sort(sorter);
        const sortedNext = [...next].sort(sorter);
        return sortedPrev.every((prev, index) => {
            return prev.account.address === sortedNext[index].account.address;
        });
    });
    const selected = useRujiraStore((state) => state.selected());
    const bridgeAccount = useRujiraStore((state) => state.bridgeAccount);
    const { connect } = useConnect();
    const { disconnect } = useDisconnect();
    const filteredAccounts = useMemo(() => {
        return accounts.map(({ account }) => account);
    }, [accounts]);
    return {
        accounts: filteredAccounts,
        selected: selected?.account,
        bridgeAccountNetwork: bridgeAccount?.network,
        connect: async (provider) => {
            const walletType = await walletTypeFromRujira(provider);
            if (walletType === WalletType.viewing) {
                throw new Error("The viewing wallet is currently unsupported");
            }
            connect({ walletType });
        },
        select: async (account) => {
            if (!account) {
                throw new Error("Missing account for select");
            }
            useRujiraStore.getState().setAccount(account);
            if (account.address) {
                const walletType = await walletTypeFromRujira(account.provider);
                useAccountStore.getState().addAccount({
                    walletType,
                    address: account.address,
                    chainId: account.network,
                });
            }
            // Keep the chain as Thorchain to prevent query errors
            // useChainStore.setState({ chainId: account.network })
        },
        disconnect: (provider) => {
            useRujiraStore.getState().removeProvider(provider);
            useRujiraStore.setState((previous) => {
                const accounts = previous.accounts.filter(({ account }) => account.provider !== provider);
                const selected = accounts.at(0);
                if (selected) {
                    useRujiraStore.getState().setAccount(selected.account);
                }
                return { accounts };
            });
        },
        disconnectAll: () => {
            disconnect();
        },
        isAvaialable: (provider) => {
            switch (provider) {
                case "Brave":
                case "Coinbase":
                case "DaoDao":
                case "Ledger":
                case "Metamask":
                case "Rabby":
                case "Tronlink":
                case "Trust":
                case "Xaman":
                    return false;
                case "Ctrl":
                case "Keplr":
                case "Leap":
                case "Okx":
                case "Station":
                case "Vultisig":
                    return true;
            }
        },
    };
};
//# sourceMappingURL=rujira.js.map